<app-card [title]="'identification.title' | translate">
  <div left-content class="content-container">
    <form [formGroup]="form">
      <div class="input-container">
        <app-input
          [label]="'identification.personNumberInputLabel' | translate"
          [placeholder]="'identification.personNumberPlaceholder' | translate"
          [control]="personNumber"
          [inputMode]="'numeric'"
          [error]="getErrors()"
          [icon]="'person'"
        ></app-input>
      </div>
      <div class="button-container">
        <app-deeplink-button
          [text]="'identification.buttonText' | translate"
          [loading]="loading"
          (buttonClicked)="login()"
        ></app-deeplink-button>
      </div>
      <div class="disclaimer-container">
        {{ "identification.disclaimer" | translate }}
      </div>
      <div class="mat-error error" *ngIf="error">
        {{ error }}
      </div>
    </form>
  </div>
  <div right-content>
    <app-contact></app-contact>
  </div>
</app-card>
